import { FoodsIconButton, Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction } from "react";
import { useDeleteActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useDeleteActionPlan";
import { Button, Dialog, DialogActions, DialogTitle, Stack, useTheme } from "@mui/material";

type Props = {
    isOpen: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    onSuccess?: () => void;
    actionPlanId: string;
};
export const DeleteModal = (props: Props) => {
    const { isOpen, setOpen, actionPlanId } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const deleteActionPlan = useDeleteActionPlan();

    return (
        <Dialog open={isOpen} fullWidth maxWidth={"xs"}>
            <DialogTitle padding={0}>
                <Stack padding={theme.spacing(2)} gap={theme.spacing(2)}>
                    <Stack flexDirection={"row"} justifyContent={"space-between"}>
                        <Typography variant="h3">
                            {t("actionPlan.deleteModal.title", "Are you sure you want to delete your action plan?")}
                        </Typography>
                        <FoodsIconButton
                            icon="close"
                            size="m"
                            buttonProps={{
                                onClick: () => {
                                    setOpen(false);
                                },
                            }}
                        />
                    </Stack>
                    <Typography variant="body">
                        {t(
                            "actionPlan.deleteModal.body",
                            "Once your action plan is deleted, all data related to it will be permanently erased. This action cannot be undone.",
                        )}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogActions
                sx={{
                    padding: 0,
                    borderTop: `1px solid ${theme.custom.grey[600]}`,
                }}
            >
                <Stack width={"100%"} gap={theme.spacing(2)} padding={theme.spacing(4)}>
                    <Button
                        variant="delete"
                        onClick={() => {
                            deleteActionPlan.mutate(
                                { actionPlanId },
                                {
                                    onSuccess: () => {
                                        props.onSuccess?.();
                                    },
                                },
                            );
                        }}
                    >
                        {t("actionPlan.deleteModal.confirm", "Permanently delete")}
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        {t("actionPlan.deleteModal.cancel", "Cancel")}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
